/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Expiry_LabelInputs */

const vi_api_keys_expiry_label = /** @type {(inputs: Api_Keys_Expiry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hết hạn`)
};

/**

* @param {Api_Keys_Expiry_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_expiry_label = /** @type {((inputs?: Api_Keys_Expiry_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Expiry_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_expiry_label(inputs)
});